import React, { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { ShieldCheck, Play, Loader2 } from "lucide-react";
import { apiClient, formatApiError } from "../../lib/api";

const fmt = (iso) => {
    if (!iso) return "noch nie";
    try {
        const d = new Date(iso);
        return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" }) +
            " " + d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
    } catch {
        return iso;
    }
};

export const GdprCard = () => {
    const [info, setInfo] = useState(null);
    const [running, setRunning] = useState(false);

    const load = useCallback(async () => {
        try {
            const { data } = await apiClient.get("/admin/gdpr-cleanup");
            setInfo(data);
        } catch (e) {
            console.error("GDPR info load failed:", e);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const run = async () => {
        setRunning(true);
        try {
            const { data } = await apiClient.post("/admin/gdpr-cleanup");
            toast.success(
                data.deleted > 0
                    ? `DSGVO-Bereinigung: ${data.deleted} Bewerbung(en) gelöscht.`
                    : "DSGVO-Bereinigung: Keine Bewerbungen zum Löschen fällig."
            );
            load();
        } catch (e) {
            toast.error(formatApiError(e?.response?.data?.detail));
        } finally {
            setRunning(false);
        }
    };

    if (!info) return null;

    return (
        <div
            data-testid="gdpr-card"
            className="flex flex-col sm:flex-row sm:items-center gap-3 bg-white border border-moebus-border rounded-lg px-4 py-3 mt-6 text-sm"
        >
            <div className="flex items-center gap-3 flex-1">
                <div className="w-8 h-8 rounded-md bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0">
                    <ShieldCheck size={16} />
                </div>
                <div className="text-slate-600">
                    <span className="font-medium text-moebus-deep">DSGVO-Löschung:</span>{" "}
                    Abgelehnte Bewerbungen werden 6 Monate nach Ablehnung, zurückgezogene 60 Tage nach Rückzug automatisch gelöscht (täglich 03:30 Uhr).
                    <span className="block sm:inline sm:ml-2 text-xs text-slate-500">
                        Letzte Bereinigung: <span data-testid="gdpr-last-run">{fmt(info.last_run)}</span>
                        {info.last_deleted != null && <> · Zuletzt gelöscht: {info.last_deleted}</>}
                        {" · "}Anstehend: <span data-testid="gdpr-pending">{info.pending}</span>
                    </span>
                </div>
            </div>
            <button
                data-testid="gdpr-run-btn"
                onClick={run}
                disabled={running}
                className="inline-flex items-center gap-2 self-start sm:self-auto bg-white border border-moebus-border text-slate-700 px-3 py-1.5 rounded-md text-xs hover:bg-slate-50 disabled:opacity-60 flex-shrink-0"
            >
                {running ? <Loader2 size={13} className="animate-spin" /> : <Play size={13} />} Jetzt ausführen
            </button>
        </div>
    );
};
